import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  useEffect(() => {
    document.title = 'g点网 - 官方入口与核心功能全解析 | 综合网络服务平台';
  }, []);

  const websiteSchema = {
    name: siteInfo.name,
    url: 'https://gpoint.com',
    description: siteInfo.description,
    inLanguage: 'zh-CN',
  };

  const webpageSchema = {
    name: 'g点网首页 - 官方入口与核心功能全解析',
    url: 'https://gpoint.com/',
    description: 'g点网是您值得信赖的综合性网络平台，提供全面的使用指南、功能介绍及常见问题解答。',
    inLanguage: 'zh-CN',
    isPartOf: { '@type': 'WebSite', name: siteInfo.name, url: 'https://gpoint.com' },
  };

  const faqSchema = {
    mainEntity: [
      { '@type': 'Question', name: '如何找到g点网官方入口？', acceptedAnswer: { '@type': 'Answer', text: '您可以直接通过浏览器访问g点网官方网站，建议收藏官方网址以备快速访问。在搜索引擎中搜索"g点网官方入口"也可快速定位到正确的官方站点。' } },
      { '@type': 'Question', name: 'g点网支持哪些注册方式？', acceptedAnswer: { '@type': 'Answer', text: 'g点网支持手机号注册、邮箱注册以及微信、QQ等第三方账号快捷登录。' } },
      { '@type': 'Question', name: '忘记密码如何找回？', acceptedAnswer: { '@type': 'Answer', text: '在登录页面点击"忘记密码"，通过绑定的手机号码或电子邮箱接收验证码，验证通过后即可设置新密码。' } },
      { '@type': 'Question', name: 'g点网如何保障用户信息安全？', acceptedAnswer: { '@type': 'Answer', text: 'g点网采用银行级数据加密技术，所有用户信息均经过严格加密存储。平台通过了多项安全认证。建议用户开启双重认证功能。' } },
      { '@type': 'Question', name: 'g点网是否收费？', acceptedAnswer: { '@type': 'Answer', text: 'g点网基础服务完全免费，同时提供付费会员服务，会员可享受去广告、专属内容、优先客服等增值权益。' } },
      { '@type': 'Question', name: '如何联系g点网客服？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过发送邮件至 service@gpoint.com，或拨打客服热线 400-888-9999 联系我们的客服团队。' } },
    ],
  };

  return (
    <>
      <SchemaOrg type="Organization" data={{
        name: siteInfo.name,
        url: 'https://gpoint.com',
        description: siteInfo.description,
        email: siteInfo.email,
        telephone: siteInfo.phone,
        address: { '@type': 'PostalAddress', addressLocality: '北京', addressCountry: 'CN' },
        foundingDate: siteInfo.founded,
      }} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="WebPage" data={webpageSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedArticles />
          <CategorySection />
          <LatestArticles />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}